// extracted by mini-css-extract-plugin
export default {"container":"ZoomContainer_container__5z73x","background":"ZoomContainer_background__NaA7H","animatedBackground":"ZoomContainer_animatedBackground__S1FRI"};